import React from 'react';
import { FaCheckCircle, FaRegCircle, FaSpinner } from 'react-icons/fa';

const steps = [
  { label: 'Inscription du restaurant', status: 'complete' },
  { label: 'Récupération de vos données sur Google Maps', status: 'complete' },
  { label: 'Analyse et modération par notre équipe', status: 'in-progress' },
  { label: "Création de la fiche restaurant sur MonResto'Halal", status: 'pending' },
  { label: "Publication de la fiche sur MonResto'Halal", status: 'pending' }
];

const StepIcon = ({ status }: { status: string }) => {
  switch (status) {
    case 'complete':
      return <FaCheckCircle className="text-success" />;
    case 'in-progress':
      return <FaSpinner className="text-primary animate-spin ring-[1px] rounded-full p-0.5 ring-primary" />;
    case 'pending':
      return <FaRegCircle className="text-gray-400" />;
    default:
      return null;
  }
};

type Props = {
  restaurantName: string;
};

export const LoadingProcess = ({ restaurantName }: Props): JSX.Element => {
  return (
    <div className="flex flex-col items-center space-y-10 w-full mx-auto">
      <h2 className="text-2xl font-medium mb-4 border px-4 py-2 rounded-xl">
        <strong>{restaurantName}</strong> est en cours de vérification
      </h2>
      <div className="flex w-full h-72 justify-center">
        <div className="h-full w-1 -mr-3 border-l-2 border-dashed border-gray-300" />
        <div className="h-full flex justify-between flex-col">
          {steps.map((step, index) => (
            <div key={index} className="flex bg-white gap-3 items-center">
              <StepIcon status={step.status} />
              <span className={`text-lg mb-0.5 ${step.status === 'complete' ? 'text-gray-800' : 'text-gray-600'}`}>{step.label}</span>
            </div>
          ))}
        </div>
      </div>
      <p>Vous serez informé par e-mail dès que votre restaurant sera publiée.</p>
    </div>
  );
};
